export const MAX_TOTAL_PAYMENT = 1000000000000;
